import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from "../components/ui/Card";
import { Button } from "../components/ui/Button";
import { Users, Database, Puzzle } from 'lucide-react';

const AdminLanding = () => {
  const navigate = useNavigate();

  return (
    <div className="container mx-auto p-6">
      <h1 className="text-3xl font-bold mb-8 text-center">Admin Dashboard</h1>
      
      <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto">
        <Card className="hover:shadow-lg transition-all duration-200">
          <CardContent className="p-6">
            <div className="flex flex-col items-center text-center space-y-4">
              <div className="p-4 bg-blue-100 rounded-full">
                <Database className="w-8 h-8 text-blue-600" />
              </div>
              <h2 className="text-2xl font-semibold">Core Items</h2>
              <p className="text-gray-600">Manage skills, agents, packages, and prompts</p>
              <Button 
                className="w-full mt-4"
                onClick={() => navigate('/marketplace/admin/core-items')}
              >
                Manage Core Items
              </Button>
            </div>
          </CardContent>
        </Card>

        <Card className="hover:shadow-lg transition-all duration-200">
          <CardContent className="p-6">
            <div className="flex flex-col items-center text-center space-y-4">
              <div className="p-4 bg-green-100 rounded-full">
                <Users className="w-8 h-8 text-green-600" />
              </div>
              <h2 className="text-2xl font-semibold">User Management</h2>
              <p className="text-gray-600">Manage user accounts and permissions</p>
              <Button 
                className="w-full mt-4"
                onClick={() => navigate('/marketplace/admin/users')}
              >
                Manage Users
              </Button>
            </div>
          </CardContent>
        </Card>

        <Card className="hover:shadow-lg transition-all duration-200">
          <CardContent className="p-6">
            <div className="flex flex-col items-center text-center space-y-4">
              <div className="p-4 bg-purple-100 rounded-full">
                <Puzzle className="w-8 h-8 text-purple-600" />
              </div>
              <h2 className="text-2xl font-semibold">Adapters</h2>
              <p className="text-gray-600">Manage and configure system adapters</p>
              <Button 
                className="w-full mt-4"
                onClick={() => navigate('/marketplace/admin/adapters')}
              >
                Manage Adapters
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default AdminLanding;